"use client";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import en from "@/locales/en.json";
import de from "@/locales/de.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";

const supportedLngs = ["en", "de", "fr", "it"] as const;

const normalizeToSupported = (language?: string | null) => {
  if (!language) return null;
  const normalized = language.toLowerCase();
  const base = normalized.split("-")[0];
  return supportedLngs.includes(normalized as typeof supportedLngs[number])
    ? normalized
    : supportedLngs.includes(base as typeof supportedLngs[number])
      ? base
      : null;
};

const detectInitialLanguage = () => {
  if (typeof window !== "undefined") {
    const widgetLocale = normalizeToSupported((window as any).__simpego_widget__?.locale);
    if (widgetLocale) return widgetLocale;

    const hashSegments = window.location.hash.split("?")[0].split("/").filter(Boolean);
    const hashLang = hashSegments.find((segment) => supportedLngs.includes(segment as typeof supportedLngs[number]));
    if (hashLang) return hashLang;
  }

  return "de";
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en,
      },
      de: {
        translation: de,
      },
      fr: {
        translation: fr,
      },
      it: {
        translation: it,
      },
    },
    lng: detectInitialLanguage(),
    fallbackLng: "de",
    supportedLngs,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
